export const TRAVEL_INSURANCE_SS_DETAILS_FORM = 'travelSs/travelDetailsForm/';

export const TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE = TRAVEL_INSURANCE_SS_DETAILS_FORM + 'setValue/';
export const TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID = TRAVEL_INSURANCE_SS_DETAILS_FORM + 'setValid/';

export const FORM_VALID_TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM = 'travelSs/travelDetailsForm/transition/formValid';
export const FORM_INVALID_TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM = 'travelSs/travelDetailsForm/transition/formInValid';

export const REINITIALIZE = 'travelSs/travelDetailsForm/state/reinitialize';

// Dropoff
export const DROP_OFF_LEAD_TRANSITION_TRAVEL_DETAILS_FORM = 'travelSs/travelDetailsForm/transition/dropOffLead';
export const dropOffLeadPersonalDetails = (value) => ({
    type: DROP_OFF_LEAD_TRANSITION_TRAVEL_DETAILS_FORM,
    value,
});

export const transitionTravelInsuranceTravelDetailsForm = {
    formValid: () => ({
        type: FORM_VALID_TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM,
    }),
    formInvalid: () => ({
        type: FORM_INVALID_TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM,
    }),
};

// API Calls actions
export const API_PENDING_TRANSITION_TRAVEL_DETAILS_FORM = `${TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_TRAVEL_DETAILS_FORM = `${TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITION_TRAVEL_DETAILS_FORM = `${TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE}/apiTransition/failure`;

export const apiTransitionPersonalDetailsForm = {
    pending: () => ({
        type: API_PENDING_TRANSITION_TRAVEL_DETAILS_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_TRAVEL_DETAILS_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_TRAVEL_DETAILS_FORM,
    }),
};

//calculated Data
export const COLLECT_TRAVEL_DETAILS_FORM_DATA =
    TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'collectPersonalDetailsData';
export const SUBMIT_TRAVEL_DETAILS_SUCCESS = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'success';
export const SUBMIT_TRAVEL_DETAILS_FAILURE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'failure';

export const collectPersonalDetailsData = () => ({
    type: COLLECT_TRAVEL_DETAILS_FORM_DATA,
});
export const submitPersonalDetailsDataSuccess = (value) => ({
    type: SUBMIT_TRAVEL_DETAILS_SUCCESS,
    value,
});
export const submitPersonalDetailsFailure = (error) => ({
    type: SUBMIT_TRAVEL_DETAILS_FAILURE,
    error,
});

//aml check
export const CALCULATE_PERSONAL_DETAILS_AML_WHITELIST_SUCCESS =
    TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'calculateAmlWhitelist';

export const TRAVEL_DETAILS_AML_WHITELIST = 'travelSsTravelDetails/amlWhitelist/';

export const TRIGGER_AML_WHITELIST_CHECK = TRAVEL_DETAILS_AML_WHITELIST + 'check/';

export const triggerAmlWhitelistCheck = () => ({
    type: TRIGGER_AML_WHITELIST_CHECK,
});

export const calculatePersonalDetailsAmlWhitelistSuccess = (value) => ({
    type: CALCULATE_PERSONAL_DETAILS_AML_WHITELIST_SUCCESS,
    value,
});

// Form Values
export const SELECTED_FORM_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'selectedForm';

export const REFERRAL_SOURCE_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'referralSouce';
export const REFERRAL_SOURCE_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'referralSource';

export const OTHER_REFERRAL_SOURCE_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'otherReferralSouce';
export const OTHER_REFERRAL_SOURCE_SET_VALID =
    TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'otherReferralSource';

export const NATIONALITY_TYPE_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'nationalityType';
export const NATIONALITY_TYPE_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'nationalityType';

export const PASSPORT_NUMBER_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'passportNumber';
export const PASSPORT_NUMBER_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'passportNumber';

export const PROFESSION_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'profession';
export const PROFESSION_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'profession';

export const TOWN_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'town';
export const TOWN_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'town';

export const POSTAL_ADDRESS_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'postalAddress';
export const POSTAL_ADDRESS_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'postalAddress';

export const TITLE_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'title';
export const TITLE_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'title';

export const FULL_NAME_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'fullName';
export const FULL_NAME_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'fullName';

export const DOB_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'DOB';
export const DOB_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'DOB';

export const ID_TYPE_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'idType';
export const ID_TYPE_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'idType';

export const ID_NUMBER_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'idNumber';
export const ID_NUMBER_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'idNumber';

export const TIN_NUMBER_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'tinNumber';
export const TIN_NUMBER_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'tinNumber';

export const PHONE_NUMBER_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'phoneNumber';
export const PHONE_NUMBER_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'phoneNumber';

export const OFFICE_NUMBER_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'officeNumber';
export const OFFICE_NUMBER_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'officeNumber';

export const EMAIL_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'email';
export const EMAIL_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'email';

export const BANK_NAME_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'bankName';
export const BANK_NAME_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'bankName';

export const BANK_HOLDER_NAME_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'bankHolderName';
export const BANK_HOLDER_NAME_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'bankHolderName';

export const BANK_ACCOUNT_NUMBER_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'bankAccountNumber';
export const BANK_ACCOUNT_NUMBER_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'bankAccountNumber';

export const BANK_BRANCH_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'bankBranch';
export const BANK_BRANCH_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'bankBranch';

export const BANK_ACCOUNT_CURRENCY_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'bankCurrency';
export const BANK_ACCOUNT_CURRENCY_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'bankCurrency';

export const PASSPORT_BIODATA_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'passportBiodata';
export const PASSPORT_BIODATA_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'passportBiodata';
export const PASSPORT_BIODATA_RESET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'reset/passportBiodata';

export const PASSPORT_DOCUMENT_ID_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'passportDocumentId';
export const PASSPORT_DOCUMENT_ID_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'passportDocumentId';

export const ID_DOCUMENT_ID_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'idDocumentId';
export const ID_DOCUMENT_ID_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'idDocumentId';

export const ID_UPLOAD_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'idUpload';
export const ID_UPLOAD_SET_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'idUpload';
export const ID_UPLOAD_RESET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'reset/idUpload';

export const CHANNEL_WAYS_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'channelWays';
export const CHANNEL_WAYS_VALID = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'channelWays';

//emergency contact details
export const EMERGENCY_CONTACT_FULL_NAME_VALUE =
    TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'emergencyFullName';
export const EMERGENCY_CONTACT_FULL_NAME_VALID =
    TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'emergencyFullName';

export const EMERGENCY_CONTACT_EMAIL_ADDRESS_VALUE =
    TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'emergencyEmailAddress';
export const EMERGENCY_CONTACT_EMAIL_ADDRESS_VALID =
    TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'emergencyEmailAddress';

export const EMERGENCY_CONTACT_PHONE_NUMBER_VALUE =
    TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'emergencyPhoneNumber';
export const EMERGENCY_CONTACT_PHONE_NUMBER_VALID =
    TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID + 'emergencyPhoneNumber';

export const SET_TRAVELLERS_ID_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'travellersId';

export const TRAVELLERS_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'travellers';

export const TRAVELLER_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'traveller';
export const UPDATE_TRAVELLER_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'updateTraveller';

export const SET_CURRENT_TRAVELLER_INDEX = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'currentTraveller';

export const CUSTOMER_SET_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'customer';
export const UPDATE_CUSTOMER_VALUE = TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'updateCustomer';

export const TRIGGER_TRAVEL_DETAILS_PASSPORT_DOCUMENT_ID_SAVE =
    TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'save/passportDocumentId';

export const triggerPassportDocumentIdSave = () => ({
    type: TRIGGER_TRAVEL_DETAILS_PASSPORT_DOCUMENT_ID_SAVE,
});

export const TRIGGER_TRAVEL_DETAILS_ID_DOCUMENT_ID_SAVE =
    TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'save/idDocumentId';

export const triggerIdDocumentIdSave = () => ({
    type: TRIGGER_TRAVEL_DETAILS_ID_DOCUMENT_ID_SAVE,
});

export const TRIGGER_TRAVEL_DETAILS_DOCUMENT_UPLOAD_CHECKS =
    TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE + 'check/documentUploads';

export const triggerDocumentUploadChecks = () => ({
    type: TRIGGER_TRAVEL_DETAILS_DOCUMENT_UPLOAD_CHECKS,
});

// action creators
export const setSelectedFormValue = (value) => ({
    type: SELECTED_FORM_SET_VALUE,
    value,
});

export const setNationalityTypeValue = (value) => ({
    type: NATIONALITY_TYPE_SET_VALUE,
    value,
});
export const setNationalityTypeValid = (error) => ({
    type: NATIONALITY_TYPE_SET_VALID,
    error,
});

export const setPassportNumberValue = (value) => ({
    type: PASSPORT_NUMBER_SET_VALUE,
    value,
});
export const setPassportNumberValid = (error) => ({
    type: NATIONALITY_TYPE_SET_VALID,
    error,
});

export const setIdNumberValue = (value) => ({
    type: ID_NUMBER_SET_VALUE,
    value,
});
export const setIdNumberValid = (error) => ({
    type: ID_NUMBER_SET_VALID,
    error,
});

export const setTinNumberValue = (value) => ({
    type: TIN_NUMBER_SET_VALUE,
    value,
});
export const setTinNumberValid = (error) => ({
    type: TIN_NUMBER_SET_VALID,
    error,
});

export const setProfessionValue = (value) => ({
    type: PROFESSION_SET_VALUE,
    value,
});
export const setProfessionValid = (error) => ({
    type: PROFESSION_SET_VALID,
    error,
});

export const setPhoneNumberValue = (value) => ({
    type: PHONE_NUMBER_SET_VALUE,
    value,
});
export const setPhoneNumberValid = (error) => ({
    type: PHONE_NUMBER_SET_VALID,
    error,
});

export const setOfficeNumberValue = (value) => ({
    type: OFFICE_NUMBER_SET_VALUE,
    value,
});
export const setOfficeNumberValid = (error) => ({
    type: OFFICE_NUMBER_SET_VALID,
    error,
});

export const setEmailValue = (value) => ({
    type: EMAIL_SET_VALUE,
    value,
});
export const setEmailValid = (error) => ({
    type: EMAIL_SET_VALID,
    error,
});

export const setPostalAddressValue = (value) => ({
    type: POSTAL_ADDRESS_SET_VALUE,
    value,
});
export const setPostalAddressValid = (error) => ({
    type: POSTAL_ADDRESS_SET_VALID,
    error,
});

export const setTownValue = (value) => ({
    type: TOWN_SET_VALUE,
    value,
});
export const setTownValid = (error) => ({
    type: TOWN_SET_VALID,
    error,
});

export const setBankNameValue = (value) => ({
    type: BANK_NAME_SET_VALUE,
    value,
});
export const setBankNameValid = (error) => ({
    type: BANK_NAME_SET_VALID,
    error,
});

export const setBankHolderNameValue = (value) => ({
    type: BANK_HOLDER_NAME_SET_VALUE,
    value,
});
export const setBankHolderNameValid = (error) => ({
    type: BANK_HOLDER_NAME_SET_VALID,
    error,
});

export const setBankAccountNumberValue = (value) => ({
    type: BANK_ACCOUNT_NUMBER_SET_VALUE,
    value,
});
export const setBankAccountNumberValid = (error) => ({
    type: BANK_ACCOUNT_NUMBER_SET_VALID,
    error,
});

export const setBankBranchValue = (value) => ({
    type: BANK_BRANCH_SET_VALUE,
    value,
});
export const setBankBranchValid = (error) => ({
    type: BANK_BRANCH_SET_VALID,
    error,
});

export const setBankAccountCurrencyValue = (value) => ({
    type: BANK_ACCOUNT_CURRENCY_SET_VALUE,
    value,
});
export const setBankAccountCurrencyValid = (error) => ({
    type: BANK_ACCOUNT_CURRENCY_SET_VALID,
    error,
});

//emergency contact info
export const setEmergencyContactFullNameValue = (value) => ({
    type: EMERGENCY_CONTACT_FULL_NAME_VALUE,
    value,
});
export const setEmergencyContactFullNameValid = (error) => ({
    type: EMERGENCY_CONTACT_FULL_NAME_VALID,
    error,
});

export const setEmergencyContactEmailAddressValue = (value) => ({
    type: EMERGENCY_CONTACT_EMAIL_ADDRESS_VALUE,
    value,
});
export const setEmergencyContactEmailAddressValid = (error) => ({
    type: EMERGENCY_CONTACT_EMAIL_ADDRESS_VALID,
    error,
});

export const setEmergencyContactPhoneNumberValue = (value) => ({
    type: EMERGENCY_CONTACT_PHONE_NUMBER_VALUE,
    value,
});
export const setEmergencyContactPhoneNumberValid = (error) => ({
    type: EMERGENCY_CONTACT_PHONE_NUMBER_VALID,
    error,
});

export const setPassportBiodataValue = (value) => ({
    type: PASSPORT_BIODATA_SET_VALUE,
    value,
});
export const setPassportBiodataValid = (error) => ({
    type: PASSPORT_BIODATA_SET_VALID,
    error,
});
export const resetPassportBiodataValue = () => ({
    type: PASSPORT_BIODATA_RESET_VALUE,
});

export const setIdUploadValue = (value) => ({
    type: ID_UPLOAD_SET_VALUE,
    value,
});
export const setIdUploadValid = (error) => ({
    type: ID_UPLOAD_SET_VALID,
    error,
});
export const resetIdUploadValue = () => ({
    type: ID_UPLOAD_RESET_VALUE,
});

export const setPassportDocumentIdValue = (value) => ({
    type: PASSPORT_DOCUMENT_ID_VALUE,
    value,
});
export const setPassportDocumentIdValid = (error) => ({
    type: PASSPORT_DOCUMENT_ID_VALUE,
    error,
});

export const setIdDocumentIdValue = (value) => ({
    type: ID_DOCUMENT_ID_VALUE,
    value,
});
export const setIdDocumentIdValid = (error) => ({
    type: ID_DOCUMENT_ID_VALID,
    error,
});

export const setTitleValue = (value) => ({
    type: TITLE_SET_VALUE,
    value,
});

export const setTitleValid = (error) => ({
    type: TITLE_SET_VALID,
    error,
});

export const setFullNameValue = (value) => ({
    type: FULL_NAME_SET_VALUE,
    value,
});

export const setFullNameValid = (error) => ({
    type: FULL_NAME_SET_VALID,
    error,
});

export const setDOBValue = (value) => ({
    type: DOB_SET_VALUE,
    value,
});
export const setDOBValid = (error) => ({
    type: DOB_SET_VALID,
    error,
});

export const setTravellersValue = (value) => ({
    type: TRAVELLERS_SET_VALUE,
    value,
});

export const setTravellerValue = (value) => ({
    type: TRAVELLER_SET_VALUE,
    value,
});

export const updateTravellerValue = (value, id) => ({
    type: UPDATE_TRAVELLER_VALUE,
    value,
    id,
});

export const setCustomerValue = (value) => ({
    type: CUSTOMER_SET_VALUE,
    value,
});

export const setIdTypeValue = (value) => ({
    type: ID_TYPE_SET_VALUE,
    value,
});

export const setIdTypeValid = (error) => ({
    type: ID_TYPE_SET_VALID,
    error,
});

export const setReferralSourceValue = (value) => ({
    type: REFERRAL_SOURCE_SET_VALUE,
    value,
});

export const setReferralSourceValid = (error) => ({
    type: REFERRAL_SOURCE_SET_VALID,
    error,
});

export const setOtherReferralSourceValue = (value) => ({
    type: OTHER_REFERRAL_SOURCE_SET_VALUE,
    value,
});

export const setOtherReferralSourceValid = (error) => ({
    type: OTHER_REFERRAL_SOURCE_SET_VALID,
    error,
});

export const setCurrentTravellerIndex = (value) => ({
    type: SET_CURRENT_TRAVELLER_INDEX,
    value,
});

export const setTravellerIdValue = (value) => ({
    type: SET_TRAVELLERS_ID_VALUE,
    value,
});

export const reinitalizeForm = () => ({
    type: REINITIALIZE,
});


export const setChannelWayValue = (value) => ({
    type: CHANNEL_WAYS_VALUE,
    value,
});
export const setChannelWayValid = (error) => ({
    type: CHANNEL_WAYS_VALID,
    error,
});

